import { render, staticRenderFns } from "./WidgetPackLead.vue?vue&type=template&id=a2522ef6"
import script from "./WidgetPackLead.vue?vue&type=script&lang=js"
export * from "./WidgetPackLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports